// extracted by mini-css-extract-plugin
module.exports = {"bg-cfg":"index-bg-cfg-1c2E-"};